export var BonusAccrualStatusEnum;
(function (BonusAccrualStatusEnum) {
    BonusAccrualStatusEnum["PENDING"] = "PENDING";
    BonusAccrualStatusEnum["CLAIMED"] = "CLAIMED";
})(BonusAccrualStatusEnum || (BonusAccrualStatusEnum = {}));
//# sourceMappingURL=bonus-accrual-status.enum.js.map